<template>
  <v-btn
    v-bind="activatorProps"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
    append-icon="mdi-plus"
    >دفعة
  </v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <v-text-field
            type="number"
            v-model="formData.value"
            :rules="valueRules"
            label="قيمة المبلغ المستلم"
          ></v-text-field>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>

        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["saveFunction", "item", "iconName"],
  data() {
    return {
      isActive: false,
      formData: {
        value: 0,
      },
      valueRules: [(v) => (v && v >= 0) || "minimum is 0 "],
    };
  },
  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.saveFunction(this.formData, this.mode);

        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
  },
  computed: {
    title() {
      return "إضافة استلام";
    },
  },
};
</script>
